import { gql } from '@apollo/client';

export const fetchBillingProfilesByPaymentMethodIdQuery = gql`
  query fetchBillingProfilesByPaymentMethodId($id: ID!, $searchOptions: ConnectionSearchOptions) {
    billingProfilesByPaymentMethodId(id: $id, searchOptions: $searchOptions) {
      totalCount
      billingProfiles {
        id
        name
        isActive
        shipTo {
          address1
          city
          country
          state
          postalCode
          name
        }
        numberOfSubscriptions
        numberOfCloudsites
      }
    }
  }
`;
